module.exports = require("@wildboar/x500/src/lib/modules/SelectedObjectClasses/groupOfUniqueNames.oa");